export default "__VITE_ASSET__vdhWsuFR__"